<script>
    import Vue from 'vue';
    import lang from '../services/lang';
    import DataTableComponent from 'vue2-datatable-component';
    import tableLocales from '../locales/lang/DataTableComponent';

    let locales = {};

    if (typeof tableLocales[lang.current()] !== 'undefined') {
        locales = tableLocales[lang.current()];
    }

    Vue.use(DataTableComponent, {
        locale: locales
    });

    export default DataTableComponent;
</script>

<style lang="sass">
    @import '~vue2-datatable-component/dist/min.css';

    div[name="Datatable"]
    {
        label[name="PageSizeSelect"] {
            select.-page-size-select {
                line-height: 10px!important;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// DataTableComponent.vue?318253d0